import { render, staticRenderFns } from "./ResetPd.vue?vue&type=template&id=6f0e2ba8&scoped=true"
import script from "./ResetPd.vue?vue&type=script&lang=js"
export * from "./ResetPd.vue?vue&type=script&lang=js"
import style0 from "./ResetPd.vue?vue&type=style&index=0&id=6f0e2ba8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e2ba8",
  null
  
)

export default component.exports